/* Generated by restful-react */

import React from 'react'
import { Mutate, MutateProps, useMutate, UseMutateProps } from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface StorePricesRequest {
  rfp: {
    googleSheetsUrl: string
    email: string
    roundNumber: number
  }
}

export interface StorePricesResponse {
  message: string
}

export interface StoreAwardRequest {
  rfp: {
    rfpId?: string
    googleSheetsUrl?: string
    email?: string
    roundNumber?: number
  }
}

export interface StoreAwardResponse {
  message: string
}

export interface GenerateNormFileRequest {
  rfp: {
    email: string
    googleSheetsUrl: string
    normFileTemplate: {
      file: string
      fileFileName: string
      uuid: string
    }
    salesforceRfpId: string
    shipperApplicationId?: number
    newShipperName?: string
    requestForProposalType: string
    storeInDatabase: boolean
    generateMatchingCarriers: boolean
    auditWorkspace: boolean
    pricingWorkspace: boolean
  }
}

export interface GenerateNormFileResponse {
  message: string
}

export interface RefreshNormFileRequest {
  rfp: {
    googleSheetsUrl: string
    email: string
  }
}

export interface RefreshNormFileResponse {
  message: string
}

export type StorePricesProps = Omit<
  MutateProps<StorePricesResponse, unknown, void, StorePricesRequest, void>,
  'path' | 'verb'
>

/**
 * Store prices
 */
export const StorePrices = (props: StorePricesProps) => (
  <Mutate<StorePricesResponse, unknown, void, StorePricesRequest, void>
    verb='POST'
    path='/v9/instant_rfp/store_prices'
    {...props}
  />
)

export type UseStorePricesProps = Omit<
  UseMutateProps<StorePricesResponse, unknown, void, StorePricesRequest, void>,
  'path' | 'verb'
>

/**
 * Store prices
 */
export const useStorePrices = (props: UseStorePricesProps) =>
  useMutate<StorePricesResponse, unknown, void, StorePricesRequest, void>(
    'POST',
    `/v9/instant_rfp/store_prices`,
    props
  )

export type StoreAwardProps = Omit<
  MutateProps<StoreAwardResponse, unknown, void, StoreAwardRequest, void>,
  'path' | 'verb'
>

/**
 * Store award
 */
export const StoreAward = (props: StoreAwardProps) => (
  <Mutate<StoreAwardResponse, unknown, void, StoreAwardRequest, void>
    verb='POST'
    path='/v9/instant_rfp/store_award'
    {...props}
  />
)

export type UseStoreAwardProps = Omit<
  UseMutateProps<StoreAwardResponse, unknown, void, StoreAwardRequest, void>,
  'path' | 'verb'
>

/**
 * Store award
 */
export const useStoreAward = (props: UseStoreAwardProps) =>
  useMutate<StoreAwardResponse, unknown, void, StoreAwardRequest, void>(
    'POST',
    `/v9/instant_rfp/store_award`,
    props
  )

export type GenerateNormFileProps = Omit<
  MutateProps<GenerateNormFileResponse, unknown, void, GenerateNormFileRequest, void>,
  'path' | 'verb'
>

/**
 * Generate norm file
 */
export const GenerateNormFile = (props: GenerateNormFileProps) => (
  <Mutate<GenerateNormFileResponse, unknown, void, GenerateNormFileRequest, void>
    verb='POST'
    path='/v9/instant_rfp/generate_norm_file'
    {...props}
  />
)

export type UseGenerateNormFileProps = Omit<
  UseMutateProps<GenerateNormFileResponse, unknown, void, GenerateNormFileRequest, void>,
  'path' | 'verb'
>

/**
 * Generate norm file
 */
export const useGenerateNormFile = (props: UseGenerateNormFileProps) =>
  useMutate<GenerateNormFileResponse, unknown, void, GenerateNormFileRequest, void>(
    'POST',
    `/v9/instant_rfp/generate_norm_file`,
    props
  )

export type RefreshNormFileProps = Omit<
  MutateProps<RefreshNormFileResponse, unknown, void, RefreshNormFileRequest, void>,
  'path' | 'verb'
>

/**
 * Refresh norm file
 */
export const RefreshNormFile = (props: RefreshNormFileProps) => (
  <Mutate<RefreshNormFileResponse, unknown, void, RefreshNormFileRequest, void>
    verb='POST'
    path='/v9/instant_rfp/refresh_metadata'
    {...props}
  />
)

export type UseRefreshNormFileProps = Omit<
  UseMutateProps<RefreshNormFileResponse, unknown, void, RefreshNormFileRequest, void>,
  'path' | 'verb'
>

/**
 * Refresh norm file
 */
export const useRefreshNormFile = (props: UseRefreshNormFileProps) =>
  useMutate<RefreshNormFileResponse, unknown, void, RefreshNormFileRequest, void>(
    'POST',
    `/v9/instant_rfp/refresh_metadata`,
    props
  )
